import { useState } from 'react';

export default function ContactForm({ isPopup = false, onClose }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const whatsappNumber = "919876093934"; // ← YAHAN APNA NUMBER DAAL DENA (country code ke saath)

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !phone) return alert("Please fill both fields");

    const message = `Hello KrioGym Team!\nName: ${name}\nPhone: ${phone}\nI want to know more / visit your gym.`;
    const encoded = encodeURIComponent(message);
    window.open(`https://wa.me/${whatsappNumber}?text=${encoded}`, '_blank');

    // Clear form
    setName('');
    setPhone('');
    if (onClose) onClose();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-[10px] font-bold text-slate-500 uppercase mb-1">Your Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Gursewak Singh"
          className="w-full bg-background-dark border border-slate-700 rounded-lg px-4 py-3 text-white placeholder-slate-600 focus:border-primary focus:ring-1 focus:ring-primary outline-none"
          required
        />
      </div>

      <div>
        <label className="block text-[10px] font-bold text-slate-500 uppercase mb-1">Phone Number</label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="+91 98760 93934"
          className="w-full bg-background-dark border border-slate-700 rounded-lg px-4 py-3 text-white placeholder-slate-600 focus:border-primary focus:ring-1 focus:ring-primary outline-none"
          required
        />
      </div>

      <button
        type="submit"
        className="w-full bg-primary text-black font-bold py-3.5 rounded-xl shadow-[0_0_15px_rgba(204,255,0,0.3)] hover:shadow-[0_0_25px_rgba(204,255,0,0.5)] transition-all active:scale-98"
      >
        Send via WhatsApp
      </button>
    </form>
  );
}